var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"ml-auto d-md-down-none"},[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.$t("common.footer.coreui")))]),_c('a',{attrs:{"href":"https://coreui.io/vue","target":"_blank"}},[_vm._v("CoreUI for Vue")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }